export const LoadingSkeleton = () => (
  <main className="app-shell" aria-busy="true" aria-label="Loading market intelligence">
    <div className="skeleton skeleton--header" />
    <div className="skeleton-grid">
      {Array.from({ length: 6 }, (_, index) => (
        <div className="skeleton skeleton--card" key={index} />
      ))}
    </div>
    <div className="skeleton skeleton--panel" />
  </main>
);
